"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var d3 = require("d3");
var _ = require("lodash");
var _1 = require(".");
var element_1 = require("../element");
var __1 = require("..");
var utils_1 = require("../template/utils");
var ConnectedDotChart = /** @class */ (function (_super) {
    __extends(ConnectedDotChart, _super);
    function ConnectedDotChart() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ConnectedDotChart.parseAttributeValue = function (attr, value) {
        switch (attr) {
            case "_valueKeys":
                return utils_1.parseJSON(value);
            case "_labelFunc":
                return utils_1.parseFunc(value);
            case "_isHorizontal":
                return utils_1.parseBoolean(value);
            default:
                return _super.parseAttributeValue.call(this, attr, value);
        }
    };
    ConnectedDotChart.prototype.defaultOptions = function () {
        return {
            _isHorizontal: true,
            _labelFunc: function (_, i) { return i.toString(); },
            _valueFunc: function (d, key) { return d[key]; },
        };
    };
    ConnectedDotChart.prototype.init = function () {
        var _this = this;
        this._toolTip = __1.tooltip.create("dottip");
        this._dotScale = d3.scaleLinear();
        var getXOrY = function (isX) {
            return function (_, i) { return isX === _this._isHorizontal ? 0 : (i + 0.5) * _this._lineSpace; };
        };
        this._groups = this.appendGroupT(_1.Component).data([]).options({
            _x: getXOrY(true),
            _y: getXOrY(false),
        });
        this._lines = this._groups.appendT(element_1.Path).options({
            d: function (d) {
                return _this._valueKeys.map(function (k, i) {
                    var arr = [0, _this._dotScale(_this._valueFunc(d, k))];
                    return "" + (i === 0 ? "M" : "L") + (_this._isHorizontal ? arr.reverse() : arr).join();
                }).join();
            },
        });
        this._labels = this._groups.appendT(element_1.Text).options({
            _text: function (d) { return _this._labelFunc(d); },
            _anchor: function (_) { return _this._isHorizontal ? 64 /* Right */ | 8 /* Bottom */ : 32 /* Center */ | 2 /* Top */; },
            _y: function (_) { return _this._isHorizontal ? 0 : _this._cachedHeight; },
        });
        this._circles = this._groups.appendGroupT(element_1.Circle).data([]).options({
            _data: function (d) { return _this._valueKeys.map(function (k) { return ({ dotPos: _this._valueFunc(d, k), class: k }); }); },
            _anchor: 32 /* Center */ | 4 /* Middle */,
            _r: 2,
            _x: function (d) { return _this._isHorizontal ? _this._dotScale(d.dotPos) : 0; },
            _y: function (d) { return _this._isHorizontal ? 0 : _this._dotScale(d.dotPos); },
            _$postAppend: function () {
                _this._toolTip.attachTo(_this._circles.dom)
                    .renderHTML(function (d) { return d.class + ": " + d.dotPos; });
            },
        });
    };
    ConnectedDotChart.prototype.postOptionsUpdate = function () {
        this._isHorizontal = this.getOption("_isHorizontal");
        this._labelFunc = this.getOption("_labelFunc");
        this._valueFunc = this.getOption("_valueFunc");
        this._valueKeys = this.getOption("_valueKeys");
    };
    ConnectedDotChart.prototype.prepare = function () {
        var _this = this;
        this._cachedHeight = this._getGeometry("_height", false);
        this._cachedWidth = this._getGeometry("_width", true);
        this._lineSpace = this._isHorizontal ? this._cachedHeight / this.datum.length : this._cachedWidth / this.datum.length;
        var valueFunc = this.getOption("_valueFunc");
        // Get the maximum and minimun value of the points to set the horizontal scale
        var flattenData = _.flatten(this.datum.map(function (d) { return _this._valueKeys.map(function (s) { return valueFunc(d, s); }); }));
        var extents = d3.extent(flattenData);
        this._dotScale.domain(extents).nice().range(this._isHorizontal ? [0, this._cachedWidth] : [this._cachedHeight, 0]);
        this._groups.data(this.datum);
        this.setupProxy({
            xAxis: function (axis) {
                axis.options({
                    _scale: _this._dotScale,
                    _gravity: _this._isHorizontal ? __1.Gravity.Bottom : __1.Gravity.Left,
                    _x: 0,
                    _y: _this._isHorizontal ? _this._cachedHeight : 0,
                });
            },
            line: "_lines",
            circle: "_circles",
            label: "_labels",
        });
    };
    return ConnectedDotChart;
}(_1.Component));
exports.ConnectedDotChart = ConnectedDotChart;
//# sourceMappingURL=connected-dot-chart.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/bvd3/dist/component/connected-dot-chart.js
// module id = 1164
// module chunks = 0 1